module.exports = __webpack_public_path__ + "static/media/background.775a1144.jpg";